import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  searchTerm?: string;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const AssistantPagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  pageSize,
  searchTerm,
  onPageChange,
  onPageSizeChange,
}) => {
  return (
    <div className="flex justify-center items-center gap-2 mt-10 mb-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 border rounded-md disabled:opacity-50 hover:bg-gray-50"
      >
        Previous
      </button>

      {Array.from({ length: totalPages }, (_, i) => {
        const page = i + 1;
        if (
          page === 1 ||
          page === totalPages ||
          (page >= currentPage - 2 && page <= currentPage + 2)
        ) {
          return (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`px-3 py-1 border rounded-md ${
                currentPage === page
                  ? "bg-gray-900 text-white"
                  : "hover:bg-gray-50"
              }`}
            >
              {page}
            </button>
          );
        } else if (page === currentPage - 3 || page === currentPage + 3) {
          return <span key={page}>...</span>;
        }
        return null;
      })}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 border rounded-md disabled:opacity-50 hover:bg-gray-50"
      >
        Next
      </button>

      <div className="ml-4 flex items-center gap-2">
        <label htmlFor="page-size" className="text-sm">
          Page Size:
        </label>
        <select
          id="page-size"
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
          className="px-2 py-1 border border-gray-300 rounded-md"
        >
          {[6, 12, 18, 24, 30].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default AssistantPagination;
